import { defineNuxtPlugin } from 'nuxt/app'
import { ObserveVisibility } from 'vue-observe-visibility'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('observe-visibility', {
    beforeMount: (el, binding, vnode) => {
      vnode.context = binding.instance
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- vue-observe-visibility is untyped
      ObserveVisibility.bind(el, binding, vnode)
    },
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- vue-observe-visibility is untyped
    update: ObserveVisibility.update,
    unmounted: (el, binding, vnode) => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- vue-observe-visibility is untyped
      if (el && ObserveVisibility && ObserveVisibility.unbind) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access -- vue-observe-visibility is untyped
        ObserveVisibility.unbind(el, binding, vnode)
      }
    },
  })
})
